import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { nanoid } from 'nanoid'

import Button from '../Button'
import DropdownButton from '../DropdownButton'
import FilterGroups from '../FilterGroups'
import FilterRow from '../FilterRow'

const FilterDropdown = ({
  filters,
  setFilters,
  scrubFilters,
  filterOptions,
  schema,
  disabled = false,
  isFormattingTag = true,
  filterGroupsConfig,
  dropdownButtonClass
}) => {
  const validFilters = scrubFilters(filters)
  let finalDropdownButtonClass = dropdownButtonClass
  if (validFilters.length === 0 && !dropdownButtonClass) {
    finalDropdownButtonClass = 'table-button-muted'
  }
  const addFilter = () => {
    const newFilter = {
      id: nanoid(),
      filterKey: '',
      type: '',
      operatorValue: '',
      filterValue: ''
    }
    setFilters([...filters, newFilter])
  }

  const updateFilter = (id, filter) => {
    const updated = filters.map((f) => (f.id === id
      ? filter
      : f))
    setFilters(updated)
  }

  const deleteFilter = (filter) => {
    const deleted = filters.filter((f) => f.id !== filter.id)
    setFilters(deleted)
  }

  useEffect(() => {
    if (filters.length === 0) {
      const newFilter = {
        id: nanoid(),
        filterKey: '',
        type: '',
        operatorValue: '',
        filterValue: ''
      }
      setFilters([...filters, newFilter], true)
    }
  }, [filters, setFilters])

  return (
    <DropdownButton
      className={finalDropdownButtonClass}
      ghost
      disabled={disabled}
      options={[
        {
          text: true,
          content: (
            <>
              <div style={{ maxHeight: '325px' }} className='overflow-y-auto overflow-y-auto border-bottom'>
                {filters.map((filter, i) => (
                  <FilterRow
                    key={i}
                    index={i}
                    schema={schema}
                    filterOptions={filterOptions}
                    filter={filter}
                    updateFilter={updateFilter}
                    deleteFilter={deleteFilter}
                    isFormattingTag={isFormattingTag}
                  />
                ))}
              </div>
              {/* Buttons */}
              <div className='d-flex flex-column flex-sm-row pt-2'>
                <div>
                  <Button ghost onClick={addFilter} className='text-nowrap me-2'>
                    <span className='fa-solid fa-plus' /> Add Filter
                  </Button>
                </div>

                {/* Filter Groups */}
                {filterGroupsConfig?.useGet &&
                  filterGroupsConfig.useCreate &&
                  filterGroupsConfig.useUpdate &&
                  filterGroupsConfig.useDelete &&
                  filterGroupsConfig.tableKey && (
                    <FilterGroups
                      filterGroupsConfig={filterGroupsConfig}
                      filters={filters}
                      setFilters={setFilters}
                    />
                  )}
              </div>
            </>
          )
        }
      ]}
    >
      <span className='fa-solid fa-filter' /> Filter {validFilters.length > 0 ? `(${validFilters.length})` : ''}
    </DropdownButton>
  )
}

FilterDropdown.propTypes = {
  filters: PropTypes.array,
  setFilters: PropTypes.func,
  scrubFilters: PropTypes.func,
  filterOptions: PropTypes.array,
  schema: PropTypes.array,
  disabled: PropTypes.bool,
  isFormattingTag: PropTypes.bool,
  filterGroupsConfig: PropTypes.object,
  dropdownButtonClass: PropTypes.string
}

export default FilterDropdown
